export default "/_next/static/images/f77b75be494f88816da42dcaeb958f1e.jpg";